export default "__VITE_ASSET__DoI5fy_2__"